import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useOcurrencesChartsDataContext } from './hooks/useOcurrencesChartsDataContext';

export const AnualOcurrencesEvolution = () => {
    const { chartData } = useOcurrencesChartsDataContext();

    return (
        <SimpleBars
            title={'Total de Ocorrências por ano'}
            horizontal={false}
            subtitles={chartData?.annualOcurrencesEvolution?.map((item) => item.description)}
            values={chartData?.annualOcurrencesEvolution?.map((item) => item.total || 0)}
        />
    );
};